import { Outlet } from 'react-router-dom'

import { SiteEntitlementsProvider } from '_providers/site-entitlements.provider'

import { SiteTimezoneProvider } from '../../contexts/site-timezone.context'

/**
 * SiteUrlSync Component
 *
 * Wrapper component for site-level routes where siteId is part of the URL path.
 * With path-based routing (/s/:siteId/*), the siteId is automatically available
 * via useParams() and synced to the store by NavigationGuard.
 *
 * Also supplies the current location's entitlements (OC-320): wrapping the site
 * outlet in SiteEntitlementsProvider shadows the brand-level provider so
 * site-scoped feature gates resolve against the site's plan (with any
 * planTierOverride), not the brand's.
 *
 * Route structure:
 * - /s/:siteId/* - Site-level routes (clients, schedule, payments, etc.)
 * - /c/* - Corporate-level routes (user-access, control-center, etc.)
 *
 * @example
 * // In router.jsx
 * {
 *   path: 's/:siteId',
 *   element: <SiteUrlSync />,
 *   children: [
 *     CLIENTS_ROUTES,
 *     SETTINGS_ROUTES,
 *     // ... all site-level routes
 *   ]
 * }
 */
export const SiteUrlSync: React.FC = () => {
  return (
    <SiteEntitlementsProvider>
      <SiteTimezoneProvider>
        <Outlet />
      </SiteTimezoneProvider>
    </SiteEntitlementsProvider>
  )
}

export default SiteUrlSync
